var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "#F8F9FA",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M16.877 40.697c-.397-.198-.596-.694-.596-1.19V17.186c0-.396.1-.694.199-1.09.1-.2.298-.398.497-.596 4.27 4.266 8.442 8.531 12.613 12.797-4.27 3.968-8.442 8.135-12.713 12.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M33.763 23.933c-1.192 1.19-2.483 2.381-3.675 3.67-3.973-4.067-8.045-8.134-12.018-12.201 0 0 0-.1.1-.1 5.164 2.878 10.329 5.755 15.593 8.631"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M18.07 40.7c3.973-3.969 8.045-7.937 12.018-11.905 1.092 1.091 2.284 2.182 3.575 3.373-5.164 2.877-10.329 5.754-15.493 8.531z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M34.36 31.77c-1.291-1.19-2.483-2.38-3.774-3.571l3.873-3.869c.398.199.795.397 1.192.695.993.595 2.086 1.09 3.08 1.686.297.1.496.298.694.595q.597.744 0 1.488c-.198.199-.397.397-.695.496-1.39.893-2.88 1.687-4.37 2.48"
})));
export default SvgGooglePlay;